import { computed, ref } from "vue";
import { defineStore } from "pinia";
import request from "@/utils/request";
import { VERIFY_STATUS } from "@/utils/constants";

export default defineStore("profile", () => {
  const profile = ref({});

  const isAdmin = computed(() => !!profile.value.is_admin);
  // const isAdmin = computed(() => true);

  const isRealnameUnsubmit = computed(() => [VERIFY_STATUS.VERIFY_UNSUBMIT].includes(profile.value.real_status));
  const isRealnameVerifing = computed(() => [VERIFY_STATUS.VERIFY_SUBMITTING].includes(profile.value.real_status));
  const isRealnameVerified = computed(() => [VERIFY_STATUS.VERIFY_RESOLVE].includes(profile.value.real_status));
  const isRealnameRejected = computed(() => [VERIFY_STATUS.VERIFY_REJECT].includes(profile.value.real_status));

  async function initProfile() {
    try {
      const res = await request.get("/contest/user/profile");
      profile.value = res.data;
      return Promise.resolve(res);
    } catch (err) {
      console.error(err);
      return Promise.reject(err);
    }
  }

  return {
    profile,
    isAdmin,
    isRealnameUnsubmit,
    isRealnameVerifing,
    isRealnameVerified,
    isRealnameRejected,
    initProfile,
  };
});
